/**
 * @generated SignedSource<<ba705068279417858af0d5771b775b04>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "direction"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "routeId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "time"
},
v4 = [
  {
    "kind": "Variable",
    "name": "date",
    "variableName": "date"
  },
  {
    "kind": "Variable",
    "name": "direction",
    "variableName": "direction"
  },
  {
    "kind": "Variable",
    "name": "route",
    "variableName": "routeId"
  },
  {
    "kind": "Variable",
    "name": "time",
    "variableName": "time"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gtfsId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectVehicleContainerFuzzyRowQuery",
    "selections": [
      {
        "alias": "trip",
        "args": (v4/*: any*/),
        "concreteType": "Trip",
        "kind": "LinkedField",
        "name": "fuzzyTrip",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SelectVehicleRow_trip"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SelectVehicleContainerFuzzyRowQuery",
    "selections": [
      {
        "alias": "trip",
        "args": (v4/*: any*/),
        "concreteType": "Trip",
        "kind": "LinkedField",
        "name": "fuzzyTrip",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Pattern",
            "kind": "LinkedField",
            "name": "pattern",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headsign",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Stop",
                "kind": "LinkedField",
                "name": "stops",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Route",
            "kind": "LinkedField",
            "name": "route",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shortName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "longName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "75fa4f4bcd4b8d654c80cb2e1a2fae39",
    "id": null,
    "metadata": {},
    "name": "SelectVehicleContainerFuzzyRowQuery",
    "operationKind": "query",
    "text": "query SelectVehicleContainerFuzzyRowQuery(\n  $routeId: String!\n  $direction: Int!\n  $time: Int!\n  $date: String!\n) {\n  trip: fuzzyTrip(route: $routeId, direction: $direction, time: $time, date: $date) {\n    ...SelectVehicleRow_trip\n    id\n  }\n}\n\nfragment SelectVehicleRow_trip on Trip {\n  gtfsId\n  pattern {\n    code\n    headsign\n    stops {\n      name\n      id\n    }\n    id\n  }\n  route {\n    gtfsId\n    mode\n    shortName\n    type\n    longName\n    color\n    id\n  }\n}\n"
  }
};
})();

node.hash = "ed482b79a3dbb3e88c9c7997a0d9782f";

module.exports = node;
